import { render, staticRenderFns } from "./page-embedded-player.vue?vue&type=template&id=cfde37f4&"
import script from "./page-embedded-player.vue?vue&type=script&lang=js&"
export * from "./page-embedded-player.vue?vue&type=script&lang=js&"
import style0 from "./page-embedded-player.vue?vue&type=style&index=0&id=cfde37f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports